import { render, staticRenderFns } from "./createNewTeamModal.vue?vue&type=template&id=17612158"
import script from "./createNewTeamModal.vue?vue&type=script&lang=js"
export * from "./createNewTeamModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports